// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

.description_description_ulcYA {
  max-height: 250px;
  overflow: auto;
  white-space: pre-line;
  overflow-wrap: break-word;
  line-height: 1.5em;
  padding: 0.5rem;
  margin: 5px 0 8px 0;
  border: 1px solid var(--badge-border);
  background-color: var(--badge-background);
  border-radius: 0.5rem;
}

.description_description_ulcYA a {
  font-weight: bold;
  text-decoration: none;
}

.description_header_GMj_E {
  font-weight: bold;
  font-size: 1em;
  margin: 0;
  padding: 0;
}

.description_divider_L2BGW {
  margin-top: 8px;
}

.description_project-link_J8jzs {
  margin-bottom: 2px;
}
`, "",{"version":3,"sources":["webpack://./src/components/tw-description/description.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,qCAAqC;EACrC,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n.description {\n  max-height: 250px;\n  overflow: auto;\n  white-space: pre-line;\n  overflow-wrap: break-word;\n  line-height: 1.5em;\n  padding: 0.5rem;\n  margin: 5px 0 8px 0;\n  border: 1px solid var(--badge-border);\n  background-color: var(--badge-background);\n  border-radius: 0.5rem;\n}\n\n.description a {\n  font-weight: bold;\n  text-decoration: none;\n}\n\n.header {\n  font-weight: bold;\n  font-size: 1em;\n  margin: 0;\n  padding: 0;\n}\n\n.divider {\n  margin-top: 8px;\n}\n\n.project-link {\n  margin-bottom: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"description": `description_description_ulcYA`,
	"header": `description_header_GMj_E`,
	"divider": `description_divider_L2BGW`,
	"project-link": `description_project-link_J8jzs`,
	"projectLink": `description_project-link_J8jzs`
};
export default ___CSS_LOADER_EXPORT___;
